import { Link } from "react-router-dom";
import { ArrowUpRight, BadgeCheck, Instagram } from "lucide-react";
import { SaveClubButton } from "@/components/SaveClubButton";

export const ClubRow = ({ club, index }) => (
  <div className="relative">
  <Link
    to={`/clubs/${club.slug}`}
    data-testid={`club-row-${club.slug}`}
    className="group grid grid-cols-12 items-center gap-3 border-b border-white/10 py-5 px-2 hover:bg-white hover:text-ink transition-colors duration-300"
  >
    <span className="col-span-1 font-mono-label text-white/30 group-hover:text-ink/40 hidden md:block">
      {String(index + 1).padStart(3, "0")}
    </span>
    <div className="col-span-8 md:col-span-5">
      <div className="flex items-center gap-2">
        <h3 className="font-display text-xl md:text-2xl leading-tight">{club.name}</h3>        {club.verified && <BadgeCheck size={16} className="shrink-0 opacity-70" data-testid={`verified-badge-${club.slug}`} />}
        {club.guide && (
          <span data-testid={`score-badge-${club.slug}`} className="font-mono-label bg-white text-ink px-2 py-1 shrink-0 group-hover:bg-ink group-hover:text-white transition-colors duration-300">
            {club.guide.score}
          </span>
        )}
      </div>
      <p className="font-mono-label text-white/40 group-hover:text-ink/50 mt-1">
        {club.is_national ? "NATIONAL / MULTI-CITY" : `${club.city}, ${club.state}`}
        {club.neighborhood ? ` · ${club.neighborhood}` : ""}
      </p>
    </div>
    <div className="col-span-3 hidden md:flex flex-wrap gap-1.5">
      {(club.tags || []).slice(0, 2).map((t) => (
        <span key={t} className="font-mono-label border border-white/20 group-hover:border-ink/20 px-2 py-1">
          {t}
        </span>
      ))}
    </div>
    <div className="col-span-2 hidden md:block">
      {club.instagram && (
        <span className="flex items-center gap-1.5 font-mono-label text-white/50 group-hover:text-ink/60">
          <Instagram size={12} /> @{club.instagram}
        </span>
      )}
    </div>
    <div className="col-span-4 md:col-span-1 flex justify-end pr-9">
      <ArrowUpRight size={20} className="opacity-40 group-hover:opacity-100 transition-opacity duration-200" />
    </div>
  </Link>
  <SaveClubButton
    slug={club.slug}
    className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-white opacity-40 hover:opacity-100 mix-blend-difference transition-opacity duration-150"
  />
  </div>
);
